import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Box, Stack } from '@mui/material';
import CreditNoteTable from '../components/CreditNoteTable';
import useDocumentFilters from '../../../components/filters/DocumentFilterHelper';
import DocumentListFilters from '../../../components/filters/DocumentListFilters';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

function CreditNoteListPage({ isPurchase }) {
  useDocumentTitle('Credit Note List');
  const { eInvoiceListPage } = useTranslatedMessages();
  const persistKey = isPurchase ? 'purchases/documents:credit-notes' : 'sales/documents:credit-notes';

  const filters = [
    {
      type: 'search',
      options: [
        {
          key: 'document_number',
          placeholder: eInvoiceListPage?.filters?.credit_note_number_label ?? 'Credit Note Number',
        },
        { key: 'billed_to_name', placeholder: eInvoiceListPage?.filters?.billed_to_name ?? 'Buyer Name' },
        { key: 'billed_to_vat', placeholder: eInvoiceListPage?.filters?.billed_to_vat ?? 'Buyer VAT' },
        { key: 'billed_by_name', placeholder: eInvoiceListPage?.filters?.billed_by_name ?? 'Seller Name' },
        { key: 'billed_by_vat', placeholder: eInvoiceListPage?.filters?.billed_by_vat ?? 'Seller VAT' },
      ],
    },
  ];

  const {
    selectedFilter,
    searchTerm,
    currentQuery,
    selectedStatus,
    dateRange,
    includeResubmitted,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleStatusChange,
    handleDateRangeChange,
    handleIncludeResubmittedChange,
    handlePaginationChange,
  } = useDocumentFilters({ defaultQuery: {}, searchOnChange: true, persistKey });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box mb={2}>
        <DocumentListFilters
          filters={filters}
          selectedFilter={selectedFilter}
          onFilterChange={handleFilterChange}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          onSearchKeyPress={handleSearchKeyPress}
          selectedStatus={selectedStatus}
          onStatusChange={handleStatusChange}
          dateRange={dateRange}
          onDateRangeChange={handleDateRangeChange}
          includeResubmitted={includeResubmitted}
          onIncludeResubmittedChange={handleIncludeResubmittedChange}
        />
      </Box>
      <CreditNoteTable
        handlePaginationChange={handlePaginationChange}
        searchQuery={currentQuery}
        isPurchase={isPurchase}
      />
    </Stack>
  );
}

export default CreditNoteListPage;
